(ns dashboard.views.settings.bookings
  (:require
   [clojure.string :refer [blank?]]
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.subs.event-organizer :as event-organizer-subs]
   [dashboard.utils :refer
    [listen vec-remove format-date format-time]]
   [dashboard.events.bookings :as booking-events]
   [dashboard.components.datepicker :refer [datepicker]]
   [dashboard.components.drawer :refer [drawer]]
   [dashboard.components.dialog :refer [dialog]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.inputs :refer [input textarea]]
   [dashboard.components.select :refer [select time-select]]
   [dashboard.components.table :refer [table]]
   [dashboard.components.tooltip :refer [tooltip]]
   [headlessui-reagent.core :as ui]
   ["date-fns" :refer
    [formatISO parse format isAfter isBefore]]
   ["@heroicons/react/solid" :refer
    [XIcon CloudUploadIcon CheckIcon UsersIcon AnnotationIcon CloudDownloadIcon
     TrashIcon]]))

(defn- booking-drawer-content [{:keys [state]}]
  [:div.relative.mt-6.flex-1.px-1.sm:px-2

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :booking/productName)]]
    [:div.sm:col-span-3
     [input
      {:name "予約商品名"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:booking :productName])
       :on-change #(swap! state assoc-in [:booking :productName] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :booking/externalId)]]
    [:div.sm:col-span-3
     [input
      {:name "管理番号"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:booking :externalId])
       :on-change #(swap! state assoc-in [:booking :externalId] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-1
    [:div
     [:label.block.text-xs.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :booking/roomType)]]
    [:div.sm:col-span-3
     [select
      {:selected {:id (get-in @state [:booking :roomType])
                  :name (get-in @state [:booking :roomType])}
       :items-list [{:id "VIPルーム"
                     :name "VIPルーム"}
                    {:id "セミプライベート"
                     :name "セミプライベート"}]
       :disabled? (= (:action @state) :view)
       :on-change #(swap! state assoc-in [:booking :roomType] %)
       :id-key :id
       :name-key :name}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :booking/guestFirstName)]]
    [:div.sm:col-span-3
     [input
      {:name "name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:booking :guestFirstName])
       :on-change #(swap! state assoc-in [:booking :guestFirstName] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :booking/guestFirstNameJp)]]
    [:div.sm:col-span-3
     [input
      {:name "name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:booking :guestFirstNameJp])
       :on-change #(swap! state assoc-in [:booking :guestFirstNameJp] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :booking/guestLastName)]]
    [:div.sm:col-span-3
     [input
      {:name "guest-last-name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:booking :guestLastName])
       :on-change #(swap! state assoc-in [:booking :guestLastName] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :booking/guestLastNameJp)]]
    [:div.sm:col-span-3
     [input
      {:name "guest-first-name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:booking :guestLastNameJp])
       :on-change #(swap! state assoc-in [:booking :guestLastNameJp] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :booking/inviter)]]
    [:div.sm:col-span-3
     [input
      {:name "inviter-name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:booking :inviterName])
       :on-change #(swap! state assoc-in [:booking :inviterName] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :booking/boutiqueName)]]
    [:div.sm:col-span-3
     [input
      {:name "boutique-name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:booking :boutiqueName])
       :on-change #(swap! state assoc-in [:booking :boutiqueName] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      [:div.flex
       (tr :booking/start)
       [:span.ml-1.text-primary
        "*"]]]]
    [:div.sm:col-span-3.flex.space-x-2
     [datepicker
      {:disabled? (= (:action @state) :view)
       :selected-date (get-in @state [:booking :start])
       :on-change #(swap! state assoc-in [:booking :start]
                          (parse (format (get-in @state [:booking :start]) "HH:mm") "HH:mm" %))}]
     [time-select
      {:disabled? (= (:action @state) :view)
       :start-time "06:00"
       :end-time "23:30"
       :selected {:id (format (get-in @state [:booking :start]) "HH:mm")
                  :name (format (get-in @state [:booking :start])  "HH:mm")}
       :on-change #(swap! state assoc-in [:booking :start]
                          (parse % "HH:mm" (get-in @state [:booking :start])))}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      [:div.flex
       (tr :booking/end)
       [:span.ml-1.text-primary
        "*"]]]]
    [:div.sm:col-span-3.flex.space-x-2
     [datepicker
      {:disabled? (= (:action @state) :view)
       :selected-date  (get-in @state [:booking :end])
       :on-change #(swap! state assoc-in [:booking :end]
                          (parse (format (get-in @state [:booking :end]) "HH:mm") "HH:mm" %))}]
     [time-select
      {:disabled? (= (:action @state) :view)
       :start-time "06:00"
       :end-time "23:30"
       :selected {:id (format (get-in @state [:booking :end]) "HH:mm" )
                  :name (format (get-in @state [:booking :end]) "HH:mm")}
       :on-change #(swap! state assoc-in [:booking :end]
                          (parse % "HH:mm" (get-in @state [:booking :end])))}]]]

   [:div.pt-2
    [:div.mt-1
     [textarea
      {:rows 4
       :name "comment"
       :id "comment"
       :label (tr :booking/comment)
       :default-value (get-in @state [:booking :comment])
       :on-change #(swap! state assoc-in [:booking :comment] %)}]]]

   ;; Guests table
   [:div.-mx-4.mt-2.flex.flex-col.sm:-mx-6.md:mx-0.mb-4
    [:table.divide-y.divide-gray-300
     [:thead
      [:tr
       [:th.pl-4.pr-3.text-left.text-sm.font-semibold.text-gray-900.sm:pl-6.md:pl-0.whitespace-nowrap
        {:class "py-2.5"
         :scope "col"}
        (tr :booking/accompanyingGuests)]
       [:th.pl-4.pr-3.text-left.text-sm.font-semibold.text-gray-900.sm:pl-6.md:pl-0.whitespace-nowrap
        {:class "py-2.5"
         :scope "col"}
        "性別"]
       [:th.pl-4.pr-3.text-left.text-sm.font-semibold.text-gray-900.sm:pl-6.md:pl-0.whitespace-nowrap
        {:class "py-2.5"
         :scope "col"}
        "年齢"]
       [:th.pr-3.text-right.text-sm.font-semibold.text-gray-900
        {:class "py-2.5"
         :scope "col"}]]]
     [:tbody
      (if (not (empty? (get-in @state [:booking :accompanyingGuests])))
        (doall
         (for [[idx guest] (->> (get-in @state [:booking :accompanyingGuests])
                                (map-indexed vector))]
           ^{:key (gensym)}
           [:tr
            [:td.py-1.px-2.font-semibold.text-sm.flex.items-center
             (:name guest)]
            [:td.py-1.pl-2
             (:gender guest)]
            [:td.py-1.pl-2
             (str (:age guest) "歳")]
            [:td.whitespace-nowrap.py-1.pl-2.text-right.text-sm.font-medium.pr-3
             [:a.text-primary-600.hover:text-primary-900
              {:type "button"
               :on-click #(swap! state assoc-in [:booking :accompanyingGuests]
                                 (vec-remove (into [] (get-in @state [:booking :accompanyingGuests])) idx))}
              [:> XIcon
               {:class "h-4 w-4"
                :aria-hidden true}]]]]))
        [:tr.divide-x
         [:td.py-1.px-2.text-sm.flex.items-center.whitespace-nowrap
          {:scope "row"
           :colSpan 4}
          (tr :booking/no-accompanying-guests-information)]])]
     [:tfoot
      [:tr
       [:th.hidden.pl-6.pr-3.pt-3.text-right.text-sm.font-normal.text-gray-500.sm:table-cell.md:pl-0
        {:scope "row"
         :colSpan 3}
        (tr :booking/guestNumbers)]

       [:td.pl-3.pr-4.pt-3.text-right.text-sm.text-gray-500.sm:pr-6
        (->> (get-in @state [:booking :accompanyingGuests])
             (count))]]]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-3.sm:gap-4.sm:space-y-0.mt-3
    [button
     {:on-click #(let [booking (-> (:booking @state)
                                   (dissoc :date :startTime :endTime :checkInTime :checkOutTime)
                                   (assoc
                                    :start (formatISO (:start (:booking @state)))
                                    :end (formatISO (:end (:booking @state)))))]
                   (do
                     (re-frame/dispatch
                      (case (:action @state)
                        :add [::booking-events/create-booking {:booking booking}]
                        :delete [::booking-events/delete-booking {:booking booking}]
                        :edit [::booking-events/update-booking {:booking booking}]
                        ""))
                     (reset! state {:is-open? false
                                    :booking nil
                                    :action nil})))}
     (case (:action @state)
       :add (tr :action/create)
       :delete (tr :action/delete)
       :edit (tr :action/save)
       "")]]])

(defn first-file []
  (map (fn [e]
         (let [target (.-currentTarget e)
               file (-> target .-files (aget 0))]
           (set! (.-value target) "")
           file))))

(defn- comment-tooltip [{:keys [comment]}]
  [tooltip
   [:div.mt-2.max-w-2xl.whitespace-normal
    comment]])

(defn- guests-tooltip [{:keys [guests]}]
  [tooltip
   (doall
    (for [guest guests]
      ^{:key (gensym)}
      [:div.flex.px-2
       [:span.font-semibold
        (:name guest)]
       [:span.ml-4.text-gray-600
        (:gender guest)]
       (when (some? (:age guest))
         [:span.ml-2.text-gray-600
          (str (:age guest) "歳")])]))])

(defn- import-bookings-dialog [{:keys [state]}]
  (let [imported-bookings (->> (listen ::event-organizer-subs/file-bookings)
                               (filter #(and
                                         (isAfter (:start %) (:start (listen ::event-organizer-subs/selected-event)))
                                         (isBefore (:end %) (:end (listen ::event-organizer-subs/selected-event))))))]
    [ui/transition
     {:show (:is-open? @state)}
     [ui/dialog
      {:open (:is-open? @state)
       :as "div"
       :class "relative z-40"
       :on-close #(reset! state {:is-open? false})}
      [ui/transition-child
       {:enter "ease-out duration-300"
        :enter-from "opacity-0"
        :enter-to "opacity-100"
        :leave "ease-in duration-200"
        :leave-from "opacity-100"
        :leave-to "opacity-0"}
       [ui/dialog-overlay
        {:class "fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity"}]]

      [:div.fixed.z-70.inset-0.overflow-y-auto.mt-12
       [:div.flex.items-end.justify-center.min-h-screen.pt-4.px-4.pb-20.text-center.sm:block.sm:p-0
        ;; This element is to trick the browser into centering the modal contents.
        [:span.hidden.inline-block.h-screen.align-middle
         {:aria-hidden true}
         "&#8203;"]
        [ui/transition-child
         {:enter "ease-out duration-300"
          :enter-from "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          :enter-to "opacity-100 translate-y-0 sm:scale-100"
          :leave "ease-in duration-200"
          :leave-from "opacity-100 translate-y-0 sm:scale-100"
          :leave-to "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"}
         [ui/dialog-panel
          {:class "relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl md:max-w-5xl lg:max-w-7xl sm:w-full sm:p-6"}
          [:div
           [ui/dialog-title
            {:class "text-3xl font-medium leading-6 text-gray-900 mb-4"}
            (tr :action/import-fn (tr :booking))]
           [:div
            (if (listen ::event-organizer-subs/bookings-file)
              [:div
               [:div.flex.justify-between
                [:div.flex.space-x-2.h-6.items-center
                 [:span.text-gray-700
                  (.-name (listen ::event-organizer-subs/bookings-file))]
                 [:button.rounded-md.bg-white.text-gray-400.hover:text-gray-500.focus:outline-none.focus:ring-2.focus:ring-primary-500
                  {:type "button"
                   :on-click #(re-frame/dispatch [::booking-events/remove-bookings-file])
                   :tabIndex -1}
                  [:span.sr-only
                   "Remove file"]
                  [:> XIcon
                   {:class "h-5 w-5 text-primary-500"}]]
                 [:span.ml-3
                  (str　"予約 " (count imported-bookings) "件")]]
                [:div
                 [button
                  {:on-click (fn []
                               (let [bookings (->> imported-bookings
                                                   (map #(dissoc % :date :startTime :endTime :checkInTime :checkOutTime))
                                                   (map #(assoc %
                                                                :start (formatISO (:start %))
                                                                :end (formatISO (:end %)))))]
                                 (doall
                                  (for [booking bookings]
                                    (re-frame/dispatch
                                     (if (some? (:id booking))
                                       [::booking-events/update-booking {:booking booking}]
                                       [::booking-events/create-booking {:booking (dissoc booking :id)}]))))))
                   :small? true}
                  (tr :action/sync)]]]
               [:div.mt-3
                [table
                 {:condensed? true
                  :headers [{:title (tr :booking/externalId)
                             :key :externalId
                             :render-cell (fn [external-id row]
                                            [:div.flex
                                             [:span.font-semibold
                                              external-id]
                                             (when (some? (:id row))
                                               [:> CheckIcon
                                                {:aria-hidden true
                                                 :class "ml-2 h-5 w-5 text-success"}])])}
                            {:title (tr :booking/guestId)
                             :key :clientId
                             :render-cell (fn [client-id row]
                                            [:div.flex
                                             [:span.font-semibold
                                              client-id]
                                             #_(when (some? (:id row))
                                                 [:> CheckIcon
                                                  {:aria-hidden true
                                                   :class "ml-2 h-5 w-5 text-success"}])])}
                            {:title (tr :booking/productName)
                             :key :productName
                             :render-cell (fn [product-name row]
                                            (let [existing-booking (get (listen ::event-organizer-subs/bookings-by-id) (:id row))
                                                  old-product-name (:productName existing-booking)]
                                              [:div.flex
                                               [:span.font-semibold.text-xs
                                                {:class (when (not= product-name old-product-name)
                                                          "text-danger")}
                                                product-name]
                                               (when (not (blank? (:comment row)))
                                                 [:span.relative
                                                  [:div.group
                                                   [comment-tooltip
                                                    {:comment (:comment row)}]
                                                   [:> AnnotationIcon
                                                    {:class "h-5 w-5 ml-2 text-gray-600"}]]])]))}
                            {:title (tr :booking/boutiqueName)
                             :key :boutiqueName}
                            {:title (tr :booking/inviterName)
                             :key :inviterName}
                            {:title (tr :booking/guestLastNameJp)
                             :key :guestLastNameJp}
                            {:title (tr :booking/guestFirstNameJp)
                             :key :guestFirstNameJp}
                            {:title (tr :booking/guestLastName)
                             :key :guestLastName}
                            {:title (tr :booking/guestFirstName)
                             :key :guestFirstName}

                            {:title (tr :booking/guestNumbers)
                             :key :guestNumbers
                             :render-cell (fn [guest-number row]
                                            [:div.flex
                                             [:span
                                              guest-number]
                                             (when (and (> (:guestNumbers row) 1)
                                                        (not (empty? (:accompanyingGuests row))))
                                               [:span.relative
                                                [:div.group
                                                 [guests-tooltip
                                                  {:guests (:accompanyingGuests row)}]
                                                 [:> UsersIcon
                                                  {:class "h-5 w-5 ml-2 text-gray-600"}]]])])}]
                  :actions [{:text #(if (some? (:id %))
                                      (tr :action/update)
                                      (tr :action/create))
                             :on-click #(let [booking (-> %
                                                          (dissoc :date :startTime :endTime :checkInTime :checkOutTime)
                                                          (assoc
                                                           :start (formatISO (:start %))
                                                           :end (formatISO (:end %))))]
                                          (do
                                            (re-frame/dispatch
                                             (if (some? (:id booking))
                                               [::booking-events/update-booking {:booking booking}]
                                               [::booking-events/create-booking {:booking (dissoc booking :id)}]))))}]
                  :rows imported-bookings}]
                ;; Row data table
                #_[table
                   {:condensed? true
                    :headers (->> header
                                  (map #(hash-map
                                         :title %
                                         :key %
                                         :render-cell (fn [value row]
                                                        [:div.truncate.max-w-xs
                                                         value]))))
                    :rows (->> (listen ::event-organizer-subs/bookings-file-content)
                               (rest)
                               (map #(apply assoc {} (interleave header %))))}]]]

              [:label.relative.cursor-pointer.rounded-md.bg-white.font-medium.text-primary-600.focus-within:outline-none.focus-within:ring-2.focus-within:ring-primary-500.focus-within:ring-offset-2.hover:text-primary-500
               {:for "bookings-csv-file"}
               [:span "Upload CSV file"]
               [:input#bookings-csv-file.sr-only
                {:type "file"
                 :accept ".csv"
                 :name "bookings-csv"
                 :on-change (fn [e]
                              (let [target (.-currentTarget e)
                                    file (-> target .-files (aget 0))]
                                (set! (.-value target) "")
                                (re-frame/dispatch [::booking-events/import-bookings-csv file])))}]])]]]]]]]]))

(defn comfirm-delete-all-dialog [{:keys [state bookings]}]
  [dialog
   {:state state
    :title ""
    :content [:div
              [:div.mx-auto.flex.h-12.w-12.items-center.justify-center.rounded-full.bg-primary-500
               [:> TrashIcon
                {:class "h-6 w-6 text-white"
                 :aria-hidden true}]]
              [:h3.text-base.font-semibold.leading-6.text-gray-900.text-lg
               (tr :action/confirm-fn (tr :action/delete))]
              [:div.mt-2
               [:p.text-sm.text-gray-500
                (tr :action/delete-fn (str (count bookings) "件の予約"))]]
              [:div.mt-5.sm:mt-6
               [button
                {:class "inline-flex w-full justify-center"
                 :on-click #(do
                              (doall
                               (for [booking bookings]
                                 (re-frame/dispatch [::booking-events/delete-booking {:booking booking}])))
                              (reset! state {:is-open? false}))}
                (tr :action/confirm)]]]}])

(defn content []
  (let [!drawer-state (reagent/atom {:is-open? false
                                     :booking nil
                                     :action :edit})
        !confirm-delete-all-dialog-state (reagent/atom {:is-open? false})
        !import-dialog-state (reagent/atom {:is-open? false})]
    (fn []
      (let [event (listen ::event-organizer-subs/selected-event)
            default-booking {:organizationId (:id (listen ::subs/organization))
                             :eventId (:id event)
                             :guestFirstName ""
                             :guestLastName ""
                             :guestFirstNameJp ""
                             :guestLastNameJp ""
                             :inviterId ""
                             :start (parse "10:30" "HH:mm" (:start event))
                             :end (parse "12:00" "HH:mm" (:start event))}]
        [:div
         [drawer
          {:state !drawer-state
           :title (case (:action @!drawer-state)
                    :add (tr :action/add-fn (tr :booking))
                    :delete (tr :action/delete-fn (tr :booking))
                    :edit (tr :action/edit-fn (tr :booking))
                    "")
           :content [booking-drawer-content
                     {:state !drawer-state}]}]
         [import-bookings-dialog
          {:state !import-dialog-state}]
         [comfirm-delete-all-dialog
          {:state !confirm-delete-all-dialog-state
           :bookings (listen ::event-organizer-subs/bookings)}]
         [:div.px-4.pt-6
          [:div.sm:flex.sm:items-center
           [:div.sm:flex-auto.items-center
            [:span.text-gray-600.text-sm.ml-2
             (str (listen ::event-organizer-subs/bookings-count) "件")]]
           [:div.mt-4.sm:mt-0.sm:ml-16.space-x-3.flex
            [button
             {:on-click #(reset! !drawer-state {:is-open? true
                                                :booking default-booking
                                                :action :add})}
             (tr :action/add-fn (tr :booking))]
            [button
             {:intent :intent/default
              :left-icon [:> CloudUploadIcon
                          {:class "h-5 w-5 text-gray-600 mr-2"}]
              :on-click #(reset! !import-dialog-state {:is-open? true})}
             [:span.flex.items-center

              (tr :action/import)]]
            [button
             {:intent :intent/default
              :left-icon [:> CloudDownloadIcon
                          {:class "h-5 w-5 text-gray-600 mr-2"}]
              :on-click #(re-frame/dispatch [::booking-events/excel-export
                                             (listen ::event-organizer-subs/bookings)
                                             (listen ::event-organizer-subs/selected-event)])}
             [:span.flex.items-center

              (tr :action/export)]]
            (when (= (:roleId (listen ::subs/userinfo)) "admin")
              [button
               {:left-icon [:> TrashIcon
                            {:class "h-5 w-5 mr-2"}]
                :on-click #(do
                             (reset! !confirm-delete-all-dialog-state {:is-open? true}))
                :disabled? (empty? (listen ::event-organizer-subs/bookings))}
               [:span.flex.items-center
                (tr :action/delete-all)]])]]]
         [:div.divide-y.divide-gray-200
          [:div.py-6.px-4
           [table
            {:headers [{:title (tr :booking/productName)
                        :key :productName
                        :render-cell (fn [product-name row]
                                       [:div.flex.items-center
                                        [:div.flex-shrink-0.mr-5
                                         [:div.flex.flex-col
                                          [:span.inline-flex.items-center.justify-center.rounded-full.bg-gray-200.font-semibold.h-8.w-8.text-sm
                                           (:externalId row)]]]
                                        [:div.flex.flex-col
                                         [:span.font-semibold
                                          (str (:startTime row) " → " (:endTime row))]
                                         [:span.text-gray-500
                                          (:roomType row)]]])}
                       {:title (tr :booking/guest)
                        :key :guestId
                        :render-cell (fn [guestId row]
                                       [:div.flex.flex-col
                                        [:span.flex.items-center
                                         [:span.font-semibold
                                          (str (:guestLastNameJp row) " " (:guestFirstNameJp row))]
                                         (when (not (blank? (:comment row)))
                                           [:span.relative
                                            [:div.group
                                             [comment-tooltip
                                              {:comment (:comment row)}]
                                             [:> AnnotationIcon
                                              {:class "h-4 w-4 ml-2 -mt-0.5 text-gray-600"}]]])]
                                        [:span.text-gray-500.text-xs
                                         (str (:guestLastName row) " " (:guestFirstName row))]
                                        [:span.text-gray-500.text-xs.font-mono
                                         (:clientId row)]])}
                       {:title (tr :booking/inviter)
                        :key :inviterName
                        :render-cell (fn [inviter row]
                                       [:div.flex.flex-col
                                        [:span
                                         inviter]
                                        [:span.text-gray-600.text-xs
                                         (if (blank? (:boutiqueName row))
                                           (:posName row)
                                           (:boutiqueName row))]])}
                       {:title (tr :booking/status)
                        :key :checkIn
                        :render-cell (fn [inviter row]
                                       [:div.flex.space-x-2
                                        [:div.flex.flex-col
                                         [:span.text-xs.text-center.text-gray-500
                                          (tr :booking.status/check-in)]
                                         [:span.text-xs.text-center.h-4
                                          (or (format-time (:checkIn row)) "-")]]
                                        [:div.flex.flex-col
                                         [:span.text-xs.text-center.text-gray-500
                                          (tr :booking.status/check-out)]
                                         [:span.text-xs.text-center.h-4
                                          (or (format-time (:checkOut row)) "-")]]])}]
             :rows (->> (listen ::event-organizer-subs/bookings)
                        (sort-by (juxt :date :startTime)))
             :group-by-fn #(format-date (:start %) {:day-of-week? true})
             :actions [{:name :edit
                        :text (tr :action/edit)
                        :on-click #(reset! !drawer-state {:is-open? true
                                                          :booking %
                                                          :action :edit})}
                       {:name :delete
                        :text (tr :action/delete)
                        :on-click #(reset! !drawer-state {:is-open? true
                                                          :booking %
                                                          :action :delete})}]}]]]]))))
